import DocumentForm from "@/pages/DocumentForm";

/** Every document type, loans included, runs on the same counter permissions. */
export default function NewDocumentRoute() {
  return <DocumentForm />;
}
